import { ENERGY_SOURCE_KEY } from "../bisko/energy-source-key";
export const HEATING_SYSTEM_EXCHANGE_SYSTEM_LIST = [
    {
        key: "BIOMASS",
        energySourceKey: ENERGY_SOURCE_KEY.BIOMASS,
        existingPlantExpenditureFactor: 1,
        newPlantExpenditureFactor: 1,
    },
    {
        key: "NATURAL_GAS",
        energySourceKey: ENERGY_SOURCE_KEY.NATURAL_GAS,
        existingPlantExpenditureFactor: 1.226,
        newPlantExpenditureFactor: 1.191,
    },
    {
        key: "DISTRICT_HEATING",
        energySourceKey: ENERGY_SOURCE_KEY.DISTRICT_HEATING,
        existingPlantExpenditureFactor: 1,
        newPlantExpenditureFactor: 1,
    },
    {
        key: "LPG",
        energySourceKey: ENERGY_SOURCE_KEY.LPG_STATIONARY,
        existingPlantExpenditureFactor: 1.226,
        newPlantExpenditureFactor: 1.191,
    },
    {
        key: "HEATING_OIL",
        energySourceKey: ENERGY_SOURCE_KEY.HEATING_OIL,
        existingPlantExpenditureFactor: 1.226,
        newPlantExpenditureFactor: 1.191,
    },
    {
        key: "NIGHT_STORAGE_HEATING",
        energySourceKey: ENERGY_SOURCE_KEY.ELECTRICITY_FOR_HEATING,
        existingPlantExpenditureFactor: 1.226,
        newPlantExpenditureFactor: 1.191,
    },
    {
        key: "LOCAL_HEATING",
        energySourceKey: ENERGY_SOURCE_KEY.LOCAL_HEATING,
        existingPlantExpenditureFactor: 1,
        newPlantExpenditureFactor: 1,
    },
    {
        key: "AIR_SOURCE_HEAT_PUMP",
        energySourceKey: ENERGY_SOURCE_KEY.ELECTRICITY_FOR_HEATING,
        existingPlantExpenditureFactor: 0.425,
        newPlantExpenditureFactor: 0.37,
    },
];
